import React from 'react';
import Reflux from 'reflux';
import map from 'lodash/map';
import find from 'lodash/find';
import createReactClass from 'create-react-class';

import globalActions from '../../actions/global-actions';
import listActions from '../../actions/list-actions';
import dataStore from '../../stores/data-store';
import listStateStore from '../../stores/list-state-store';
import formStateStore from '../../stores/form-state-store';

import Details from '../details';

import StandplanForm from './form';
import formActions from '../../actions/form-actions';

export default createReactClass({
	mixins: [
		Reflux.connect(listStateStore, 'ui'),
		Reflux.connect(dataStore, 'data'),
		Reflux.connect(formStateStore, 'formState'),
	],

	handleStandClick: function (event, stand) {
		event.stopPropagation();

		if (!this.state.ui.isExpanded) {
			listActions.expand();
		}
		listActions.showDetails(stand.id);
		globalActions.selectStand(stand.id);
	},

	handleHeaderTouchMove: function (e) {
		e.stopPropagation();
		e.preventDefault();

		if (this.state.ui.isExpanded) {
			listActions.collapse(true);
		}
	},

	handleClick: function () {
		if (!this.state.ui.isExpanded && this.state.ui.standId) {
			listActions.expand();
		}
	},

	handleBackToListButtonClick: function (e) {
		e.stopPropagation();
		e.preventDefault();

		listActions.showDetails(null);
		globalActions.selectStand(null);
	},

	handleToggleButtonClick: function (e) {
		e.stopPropagation();
		e.preventDefault();

		if (this.state.ui.isExpanded) {
			listActions.collapse(true);
		} else {
			listActions.expand(true);
		}
	},

	renderBackToListButton: function () {
		return (
			<button
				className="bssp-list__back-to-list-button"
				onClick={this.handleBackToListButtonClick}
				onTouchMove={(e) => e.stopPropagation()}
				onTouchStart={(e) => e.stopPropagation()}
			>
				<i className="bssp-icon bssp-icon--back-to-list" />
			</button>
		);
	},

	renderToggleButton: function () {
		const icon = (
			<i
				className={`bssp-icon bssp-icon--${
					this.state.ui.isExpanded ? 'collapse' : 'expand'
				}`}
			/>
		);
		return (
			<button
				className="bssp-list__toggle-button"
				onClick={this.handleToggleButtonClick}
				onTouchMove={(e) => e.stopPropagation()}
				onTouchStart={(e) => e.stopPropagation()}
			>
				{icon}
			</button>
		);
	},

	renderCloseButton: function () {
		return this.state.ui.standId ? (
			<button
				className="bssp-list__close-button"
				onClick={this.handleBackToListButtonClick}
				onTouchMove={(e) => e.stopPropagation()}
				onTouchStart={(e) => e.stopPropagation()}
			>
				<i className="bssp-icon bssp-icon--reset" />
			</button>
		) : null;
	},

	renderDetails: function (stand) {
		return stand?.id ? (
			<Details stand={stand} isExpanded={this.state.ui.isExpanded} />
		) : (
			''
		);
	},

	renderListItems: function () {
		return (
			<ul>
				{map(this.state.data.filteredStaende, (stand) => (
					<li
						className={`bssp-list__item bssp-list__item--${
							this.state.ui.standId === stand.id
								? 'selected'
								: this.state.ui.lastStandId === stand.id
								? 'last'
								: 'default'
						}`}
						key={stand.id}
						onClick={(event) => this.handleStandClick(event, stand)}
					>
						{stand.number ? (
							<>
								<strong className="bssp-list__number">
									{stand.number}
								</strong>{' '}
							</>
						) : null}
						<strong>{stand.name}</strong>{' '}
						<span>
							{stand.listInformation || stand.description}
						</span>
						<i className="bssp-icon bssp-icon--more-arrow" />
					</li>
				))}
			</ul>
		);
	},

	renderList: function () {
		const {selectedFilterOptionName, selectedAdditionalFilterOptionName} =
			this.state.formState;
		const content = this.state.data.filteredStaende ? (
			this.state.data.filteredStaende.length ? (
				this.renderListItems()
			) : (
				<p className="bssp-error">Keine Stände gefunden.</p>
			)
		) : (
			<p className="bssp-error">Lädt …</p>
		);

		return (
			<div>
				<StandplanForm
					categoryFilters={this.state.data.categoryFilters}
					additionalCategoryFilters={
						this.state.data.additionalCategoryFilters
					}
					categoryColorMap={this.state.data.categoryColorMap}
				/>

				<div className="bssp-list-container">
					{selectedFilterOptionName &&
					selectedAdditionalFilterOptionName ? (
						<div className="bssp-list__additional-filter">
							Filter aktiv: {selectedAdditionalFilterOptionName}
							<button
								type="button"
								onClick={() => {
									formActions.selectAdditionalFilter(
										null,
										null
									);
								}}
							>
								Alle zeigen
							</button>
						</div>
					) : null}

					{content}

					<div className="bssp-footer">
						<p>
							&copy; Stadt Braunschweig –{' '}
							<a
								href="https://www.braunschweig.de/weihnachtsmarkt/impressum.php"
								target="_blank"
								rel="noreferrer"
							>
								Impressum
							</a>
							{', '}
							<a
								href="https://www.braunschweig.de/weihnachtsmarkt/datenschutz.php"
								target="_blank"
								rel="noreferrer"
							>
								Datenschutz
							</a>
							<br />
							Fotos: Braunschweig Stadtmarketing GmbH / Daniel
							Möller / Peter Sierigk / Thomas Ammerpohl
							<br />
							Karte:{' '}
							<a
								href="https://www.openstreetmap.org/copyright"
								target="_blank"
								rel="noreferrer external"
							>
								OpenStreetMap
							</a>{' '}
							Mitwirkende (ODbL)
							<br />
							Umsetzung durch{' '}
							<a
								href="https://neonaut.de/"
								target="_blank"
								rel="noreferrer"
							>
								Neonaut GmbH
							</a>
						</p>
					</div>
				</div>
			</div>
		);
	},

	render: function () {
		const showRightPanel = !!this.state.ui.standId;
		const classes =
			'bssp-list' +
			(this.state.ui.isExpanded ? ' bssp-list--active' : '');
		const stand =
			find(this.state.data.staende, ['id', this.state.ui.standId]) ||
			this.state._standCache;
		this.state._standCache = Object.assign({}, stand);

		let title;
		let leftHeaderItem;
		if (this.state.ui.standId) {
			title = (
				<>
					{stand.number ? (
						<>
							<span className="bssp-list__number">
								{stand.number}
							</span>{' '}
						</>
					) : null}
					{stand.name}
				</>
			);
			leftHeaderItem = (
				<div className="bssp-list-header__item bssp-list-header__item--left">
					{this.renderBackToListButton()}
				</div>
			);
		} else {
			title = 'Weihnachtsmarkt 2024';
			leftHeaderItem = <span />;
		}

		const classesLeft = `bssp-list__panel bssp-list__panel--left bssp-list__panel--${
			showRightPanel ? 'hidden' : 'active'
		}`;
		const classesRight = `bssp-list__panel bssp-list__panel--right bssp-list__panel--${
			showRightPanel ? 'active' : 'hidden'
		}`;

		return (
			<div className={classes} onClick={this.handleClick}>
				<header
					className="bssp-list-header"
					onTouchMove={this.handleHeaderTouchMove}
				>
					{leftHeaderItem}
					<div className="bssp-list-header__item bssp-list-header__item--right">
						{this.renderToggleButton()}
						{this.renderCloseButton()}
					</div>
					<div className="bssp-list-header__item bssp-list-header__item--middle">
						<h1>{title}</h1>
					</div>
				</header>
				<div className={classesLeft}>{this.renderList()}</div>
				<div className={classesRight}>
					{stand ? this.renderDetails(stand) : null}
				</div>
			</div>
		);
	},
});
